import { fetchData } from "./fetchData";

export const getAGMsAndSubchainsAPI = async(jobID) => {
    const route = `/maps/sitemap?jobid=${jobID}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}